import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
//import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API_URL } from "../config";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(""); // for success or error messages
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const action = queryParams.get("action");


  const handleLogin = async (e) => {
    e.preventDefault(); // prevent page reload

    try {
      const response = await axios.post(
        `${API_URL}/api-select-user-login-api.php`,
        { email, password },
        { withCredentials: true }
      );

      // Assuming your API returns: { status: "success" / "error", message: "..." }
      const data = response.data;
      if (data.status === "success") {
        navigate("/dashboard"); // redirect on success
      } else {
        setMessage(data.message || "Login failed"); // show API error
      }

    } catch (err) {
      console.error(err);
      setMessage("An error occurred. Please try again.");
    }
  };



  return (
    <div>
      <div className='breadcrumb'><Link to="/">Home</Link> &nbsp;:&nbsp; Login</div>
      <div className='ibodywrap'>
        <div className='logreg-panel'>
          <div className='logreg-left-panel'>
            <form onSubmit={handleLogin}>
              <div className='logreg-box'>
                <h2>User Login</h2>
                {/* Show error/success message */}
                {action === "logout" && (<p style={{ color: "#00AA00", fontWeight: "600" }}>Successfully logged out.</p>)}
                {message && <div className="form-message">{message}</div>}
                <div className='form-row'><input type='text' name="email" className='lr-textbox' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='User Name*' /></div>
                <div className='form-row'><input type='password' name="password" className='lr-textbox' value={password} onChange={(e) => setPassword(e.target.value)} placeholder='Password*' /></div>
                <div className='form-row'><button type="submit" className="logreg-btn">Login</button></div>
                <div className='form-row'>Don't have an Account? <Link to="/">Sign Up</Link></div>
              </div>
            </form>
          </div>
          <div className='logreg-right-panel'>
            Left Panel
          </div>
          <div className='clr'></div>
        </div>
      </div>
    </div>
  )
}

export default Login
